import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { OrderLinePartNumbersDisplay } from "@bevco/Store/Handlers/Custom/CustomSetAddedToCartModal";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface CustomAddedToCartModalState {
    isOpen: boolean;
    cartLine?: CartLineModel;
    originalQtyOrdered?: number;
    /** Line qty for this product before the current add (0 if new line). */
    existingQtyOrdered?: number;
    isBulkAdd?: boolean;
    bulkProductCount?: number;
    isQtyAdjusted?: boolean;
    product?: ProductModel;
    productInfo?: ProductInfo;
    hasSpoolProducts?: boolean;
    /** Spool conflict notice id (e.g. order-already-in-cart) shown as message-only content. */
    spoolNoticeId?: string;
    hideViewCartButton?: boolean;
    /** When true, modal always shows quote-required UI (overrides inventory / useCustomQuoteRequired). */
    forceQuoteRequired?: boolean;
    /** Present only when the modal is opened from OrderLinesList Buy Again. */
    orderLinePartNumbers?: OrderLinePartNumbersDisplay;
}

const initialState: CustomAddedToCartModalState = {
    isOpen: false,
};

const customAddedToCartModalReducer = {
    "Custom/SetAddedToCartModal/Complete": (
        draft: Draft<CustomAddedToCartModalState>,
        action: {
            isOpen: boolean;
            cartLine?: CartLineModel;
            originalQtyOrdered?: number;
            existingQtyOrdered?: number;
            isBulkAdd?: boolean;
            bulkProductCount?: number;
            isQtyAdjusted?: boolean;
            product?: ProductModel;
            productInfo?: ProductInfo;
            hasSpoolProducts?: boolean;
            spoolNoticeId?: string;
            hideViewCartButton?: boolean;
            forceQuoteRequired?: boolean;
            orderLinePartNumbers?: OrderLinePartNumbersDisplay;
        },
    ) => {
        // Keep cartLine / bulk flags while closing so Overlay's exit animation
        // does not flash an empty (bulk-like) modal body.
        if (!action.isOpen) {
            draft.isOpen = false;
            return;
        }

        draft.isOpen = action.isOpen;
        draft.cartLine = action.cartLine;
        draft.originalQtyOrdered = action.originalQtyOrdered;
        draft.existingQtyOrdered = action.existingQtyOrdered;
        draft.isBulkAdd = action.isBulkAdd;
        draft.bulkProductCount = action.bulkProductCount;
        draft.isQtyAdjusted = action.isQtyAdjusted;
        draft.product = action.product;
        draft.productInfo = action.productInfo;
        draft.hasSpoolProducts = !!action.hasSpoolProducts;
        draft.spoolNoticeId = action.spoolNoticeId;
        draft.hideViewCartButton = !!action.hideViewCartButton;
        draft.forceQuoteRequired = !!action.forceQuoteRequired;
        draft.orderLinePartNumbers = action.orderLinePartNumbers;
    },
} as any;

export default createTypedReducerWithImmer(initialState, customAddedToCartModalReducer);
